export * from './copy.component';
